import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Card from '../ui/Card';
import Button from '../ui/Button';
import Alert from '../ui/Alert';
import { gerarLinkDownload, registrarDownload } from '../../services/downloads';

const REQUISITOS = [
  'AutoCAD / Civil 3D 2024 a 2026',
];

const DownloadCard = ({ versao, podeBaixar }) => {
  const [baixando, setBaixando] = useState(false);
  const [erro, setErro] = useState('');

  const baixar = async () => {
    setErro('');
    try {
      setBaixando(true);
      const link = await gerarLinkDownload(versao.download_url);
      await registrarDownload(versao.version);
      window.location.href = link;
    } catch (e) {
      console.error('Erro ao gerar o link de download:', e);
      setErro('Não foi possível gerar o link. Tente novamente em instantes.');
    } finally {
      setBaixando(false);
    }
  };

  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold text-rn-navy mb-6">
        Download do Plugin
      </h2>

      {erro && <Alert type="error" message={erro} className="mb-6" />}

      <div className="space-y-4 mb-6">
        <div>
          <h3 className="text-sm font-medium text-rn-text-soft mb-1">
            Última versão
          </h3>
          <p className="text-rn-navy font-medium">
            {versao ? `v${versao.version}` : 'Nenhuma publicada'}
          </p>
        </div>

        {versao?.created_at && (
          <div>
            <h3 className="text-sm font-medium text-rn-text-soft mb-1">
              Publicada em
            </h3>
            <p className="text-rn-navy">
              {new Date(versao.created_at).toLocaleDateString('pt-BR')}
            </p>
          </div>
        )}
      </div>

      <div className="space-y-4">
        {!podeBaixar && (
          <div className="p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded-r-lg text-sm">
            <p className="text-yellow-800">
              Você precisa de uma assinatura ativa para baixar o plugin.
            </p>
          </div>
        )}

        {podeBaixar && !versao && (
          <div className="p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded-r-lg text-sm">
            <p className="text-yellow-800">
              Sua assinatura está ativa, mas ainda não há versão publicada.
            </p>
          </div>
        )}

        {podeBaixar && versao && (
          <Button onClick={baixar} disabled={baixando} className="w-full">
            {baixando ? 'Preparando...' : 'Fazer download'}
          </Button>
        )}

        <Link
          to="/dashboard/downloads"
          className="block w-full text-center text-sm text-rn-text-soft hover:text-rn-navy"
        >
          Ver notas de versão
        </Link>
      </div>

      <div className="mt-6 p-4 bg-rn-bg rounded-lg">
        <h3 className="text-sm font-medium text-rn-navy mb-2">
          Requisitos do sistema
        </h3>
        <ul className="space-y-2 text-sm text-rn-text-soft">
          {REQUISITOS.map((r) => (
            <li key={r} className="flex items-center">
              <svg
                className="w-4 h-4 mr-2 text-green-500 flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
              {r}
            </li>
          ))}
        </ul>
      </div>
    </Card>
  );
};

export default DownloadCard;
